import { render } from "./download.page.vue?vue&type=template&id=23352fa1&scoped=true"
import script from "./download.page.vue?vue&type=script&lang=js"
export * from "./download.page.vue?vue&type=script&lang=js"

import "./download.page.vue?vue&type=style&index=0&id=23352fa1&scoped=true&lang=css"

import exportComponent from "E:\\work\\download-page\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23352fa1"]])

export default __exports__